import React from 'react';
import CommonBanner from '../component/Common/CommonBanner';
// import './Forms.css'; // Optional: for shared form styles

const VolunteerFormPage = () => {
    return (
        <>
            <CommonBanner heading="Volunteer With Us" pagination="Volunteer" />
            <section className="who_we_are_section section_padding">
                <div className="container">
                    <div className="who_we_are_img">
           <iframe src="https://docs.google.com/forms/d/e/1FAIpQLScwXjw7MeQAU90p6SxgvDI1KE4qInFm4FW7UPI_9scGj-RSlg/viewform?embedded=true" width="100%" height="1963" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
                    </div>
                </div>
            </section>
        </>
    );
};

export default VolunteerFormPage;
